import { Wrapper } from "./styles";

const NotAuthorized = ({ children }) => {
    return <Wrapper>{children}</Wrapper>;
};
  
export default NotAuthorized;